export default "__VITE_ASSET__CWN38L$7__"